import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "layer deletAlt" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "layerTitle" }, "알림", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "layerMain" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "layerMainText" }, " 이제부터 모든 스마트폰에서 상생레터 어플의 접속이 차단됩니다. 차단을 해제하시려면 스마트폰 앱 사용을 선택하여 주십시오. ")
], -1)
const _hoisted_4 = { class: "layerBtnArea" }
const _hoisted_5 = { class: "box" }
const _hoisted_6 = {
  class: "textArea",
  style: {"margin-bottom":"10px"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "tableTitleText left bold mgR15" }, "앱 사용설정 : ", -1)
const _hoisted_8 = { class: "tableTitleText left mgR15" }
const _hoisted_9 = { class: "tableTitleText left mgR15" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" ※ 모든 스마트폰에서 상생레터 어플을 차단하시려면 '스마트폰 앱 사용 안함'을 선택하여 주십시오."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" (간편 로그인시 체크하여 로그인정보 및 APP의 DB삭제) ")
], -1)
const _hoisted_11 = { class: "box" }
const _hoisted_12 = {
  class: "tableList",
  style: {"width":"600px"}
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"100px"} }, "선택(사용중)"),
  /*#__PURE__*/_createElementVNode("th", null, "마지막접속"),
  /*#__PURE__*/_createElementVNode("th", null, "휴대폰번호"),
  /*#__PURE__*/_createElementVNode("th", null, "모델명")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "blueBtn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.user_con_update()))
        }, "확인")
      ])
    ], 512), [
      [_vShow, $data.ui.app_layer]
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("label", _hoisted_8, [
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            name: "select",
            value: "Y",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.arr.user_conf.APP_USE_YN) = $event)),
            onChange: _cache[2] || (_cache[2] = ($event: any) => ($options.app_layer( false )))
          }, null, 544), [
            [_vModelRadio, $data.arr.user_conf.APP_USE_YN]
          ]),
          _createTextVNode("스마트폰 앱 사용 ")
        ]),
        _createElementVNode("label", _hoisted_9, [
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            name: "select",
            value: "N",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.arr.user_conf.APP_USE_YN) = $event)),
            onChange: _cache[4] || (_cache[4] = ($event: any) => ($options.app_layer( true )))
          }, null, 544), [
            [_vModelRadio, $data.arr.user_conf.APP_USE_YN]
          ]),
          _createTextVNode("스마트폰 앱 사용안함 ")
        ])
      ]),
      _hoisted_10
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("table", _hoisted_12, [
        _hoisted_13,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.arr.device_list, (r) => {
          return (_openBlock(), _createElementBlock("tr", null, [
            _createElementVNode("td", null, _toDisplayString(r.IS_USE== 1 ? '사용중' : ''), 1),
            _createElementVNode("td", null, _toDisplayString(r.REG_DT), 1),
            _createElementVNode("td", null, _toDisplayString(r.HDPH_CNO), 1),
            _createElementVNode("td", null, _toDisplayString(r.HDPH_MODEL), 1)
          ]))
        }), 256))
      ])
    ])
  ], 64))
}